export function hasStepIdentity(stepPiece) {
  return typeof stepPiece?.file_sha256 === 'string'
    && stepPiece.file_sha256.length > 0
    && Number.isInteger(stepPiece.raw_solid_ordinal)
    && Number.isInteger(stepPiece.identifier_version);
}

export function createStepGeometryFormData(stepPiece, { requireIdentity = false } = {}) {
  if (requireIdentity && !hasStepIdentity(stepPiece)) {
    throw new Error('O sólido não possui a identidade STEP V1 completa.');
  }

  const width = stepPiece.largura || stepPiece.dimensoes?.largura || 0;
  const length = stepPiece.comprimento || stepPiece.dimensoes?.comprimento || 0;
  const thickness = stepPiece.espessura || stepPiece.dimensoes?.espessura || 15;
  const holes = stepPiece.furos || [];
  const formattedHoles = {
    verticais: holes.filter((hole) => hole.tipo === 'vertical').map((hole) => ({
      x: hole.x,
      y: hole.y,
      diametro: hole.diametro,
      profundidade: hole.profundidade || 0,
      lado: hole.lado || 'LS',
    })),
    horizontais: holes.filter((hole) => hole.tipo === 'horizontal').map((hole) => ({
      x: hole.x,
      y: hole.y,
      z: hole.z,
      diametro: hole.diametro,
      profundidade: hole.profundidade || 22,
      lado: hole.lado || 'XP',
    })),
  };

  const formData = new FormData();
  formData.append('largura', String(width));
  formData.append('comprimento', String(length));
  formData.append('espessura', String(thickness));
  formData.append('furos', JSON.stringify(formattedHoles));
  formData.append('rasgos', JSON.stringify(stepPiece.rasgos || []));
  if (hasStepIdentity(stepPiece)) {
    formData.append('file_sha256', stepPiece.file_sha256);
    formData.append('raw_solid_ordinal', String(stepPiece.raw_solid_ordinal));
    formData.append('identifier_version', String(stepPiece.identifier_version));
  }
  return formData;
}

export function createStepConfirmationFormData({ file, pecaId, stepPiece }) {
  if (!file) throw new Error('O arquivo STEP original não está disponível.');
  if (!hasStepIdentity(stepPiece)) {
    throw new Error('O sólido não possui a identidade STEP V1 completa.');
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('peca_id', String(pecaId));
  formData.append('file_sha256', stepPiece.file_sha256);
  formData.append('raw_solid_ordinal', String(stepPiece.raw_solid_ordinal));
  formData.append('identifier_version', String(stepPiece.identifier_version));
  return formData;
}
